// extracted by mini-css-extract-plugin
export default {"main":"_9ccefb8f31 _26f205a3ab a63a17d1fb _02011a97f6","title":"_75419cc5ac"};